<script setup>
import { ref, computed } from "vue";
import AnTooltip from "./AnTooltip.vue";

const props = defineProps({
  values: { type: Array, required: true }, // 24 hourly counts
  rgb: { type: String, default: "56,189,248" },
});

const hoverHour = ref(-1);
const mouseX = ref(0);
const mouseY = ref(0);

const max = computed(() => Math.max(...props.values) || 1);
const cells = computed(() =>
  props.values.map((v) => ({
    bg: `rgba(${props.rgb}, ${(0.1 + 0.9 * (v / max.value)).toFixed(2)})`,
  }))
);

const tooltipTitle = computed(() =>
  hoverHour.value >= 0 ? `${hoverHour.value}:00 – ${(hoverHour.value + 1) % 24}:00` : "",
);
const tooltipRows = computed(() =>
  hoverHour.value >= 0
    ? [{ label: "Conversations", value: (props.values[hoverHour.value] ?? 0).toLocaleString(), color: `rgb(${props.rgb})` }]
    : [],
);

function onEnter(hour, e) {
  hoverHour.value = hour;
  mouseX.value = e.clientX;
  mouseY.value = e.clientY;
}

function onMove(e) {
  mouseX.value = e.clientX;
  mouseY.value = e.clientY;
}

function onLeave() {
  hoverHour.value = -1;
}
</script>

<template>
  <div>
    <div class="an-heat">
      <div
        v-for="(c, i) in cells"
        :key="i"
        class="an-heat__cell"
        :style="{ background: c.bg }"
        @mouseenter="onEnter(i, $event)"
        @mousemove="onMove"
        @mouseleave="onLeave"
      ></div>
    </div>
    <div class="an-heat__labels"><span>12a</span><span>6a</span><span>12p</span><span>6p</span><span>11p</span></div>
    <AnTooltip :visible="hoverHour >= 0" :x="mouseX" :y="mouseY" :title="tooltipTitle" :rows="tooltipRows" />
  </div>
</template>
